import { getAuthHeader } from "@src/app/superagent";
import { environmentConfig } from "@src/appV2/environment";
import { logApiFailureEvent } from "@src/lib/analytics";
import request from "superagent";

export const fetchNextTwoDaysShifts = async (tmz: string): Promise<any> => {
  return await request
    .get(`${environmentConfig.REACT_APP_BASE_API_URL}/v1/shifts/myShifts/nextTwoDays`)
    .retry(1, (err) => {
      if (!err) {
        return false;
      }
      return true;
    })
    .set(await getAuthHeader())
    .query({ tmz })
    .then(({ body }) => body.response ?? []);
};

export const checkAttendanceBulk = async (urgentShiftsServiceUrl: string, payload: any) => {
  return request
    .post(`${urgentShiftsServiceUrl}/attendance/check/bulk`)
    .set(await getAuthHeader())
    .send({ ...payload })
    .then(({ body }) => body)
    .catch(logApiFailureEvent);
};

export const getConflictingNegotiatingShifts = async (shiftId?: string): Promise<number> => {
  return await request
    .get(`${environmentConfig.REACT_APP_BASE_API_URL}/negotiation/conflicting-shifts/${shiftId}`)
    .set(await getAuthHeader())
    .then(({ body }) => body.conflictingShiftsWithNegotiations?.length || 0);
};
